
export default {
    adList: [],
    PlacementList:[],
    currentAdObject:{},
    currentAdDetails:[],
    entitiesList:[],
};
